import request from '@/axios'

// 07-根据手机号码，获取用户信息
export function getCustomerInfoEvaluation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/customer_evaluate/getCustomerInfo',
    method: 'post',
    data
  })
}

// 08-用户上门后离店评价提交
export function saveEvaluate(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/customer_evaluate/saveEvaluate',
    method: 'post',
    data
  })
}

// 09-用户评价查看页面
export function getEvaluateContent(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/customer_evaluate/getEvaluateContent',
    method: 'post',
    data
  })
}
